<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next';
import { computed } from 'vue';

import { type CompatibilityIssue } from '@/services/agent_skills';

const { issues } = defineProps<{ issues: CompatibilityIssue[] }>();

// `broken` wins over `partial` when both are present: whoever reads this needs the worst case
// the skill is in, not an average of the two.
const isBroken = computed(() =>
    issues.some((issue) => issue.severity === 'broken')
);
</script>

<template>
    <div
        v-if="issues.length"
        class="rounded-lg border px-3 py-2.5"
        :class="
            isBroken
                ? 'border-destructive/30 bg-destructive/5'
                : 'border-yellow25 bg-yellow25/25 dark:bg-yellowContrast25/10'
        "
    >
        <p
            class="flex items-center gap-1.5 text-xs font-medium"
            :class="
                isBroken
                    ? 'text-destructive'
                    : 'text-yellow100 dark:text-yellowContrast25'
            "
        >
            <AlertTriangle class="h-3.5 w-3.5 shrink-0" />
            <template v-if="isBroken">
                Some steps will not run as written
            </template>
            <template v-else>Some supporting material is missing</template>
        </p>
        <ul class="mt-1.5 space-y-1 text-xs text-foreground80">
            <li v-for="issue in issues" :key="issue.message">
                {{ issue.message }}
            </li>
        </ul>
    </div>
</template>
